var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"account-plan",style:({ backgroundColor: 'gray' })},[_vm._v("\n  "+_vm._s(_vm.displayInfo.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }